import React, {memo, useEffect} from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {useSelector} from 'react-redux';
import {browserHistory} from 'react-router';
import styled from 'styled-components';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {AttachTooltip} from 'app/general/overlays';
import {cats, withShortcuts} from 'app/general/shortcuts/withShortcuts';
import {NOTIFICATIONS_PAGE_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';

import type {WithShortcutsProps} from 'app/general/shortcuts/withShortcuts';

export const NotificationsIcon = memo(
  withShortcuts({
    key: 'n',
    name: () => gt('Go to Notifications page'),
    category: cats.everywhere,
  })(function NotificationsIcon({
    enableShortcut,
  }: WithShortcutsProps): JSX.Element {
    useEffect(() => {
      enableShortcut('n', () => browserHistory.push(NOTIFICATIONS_PAGE_URL));
    }, []);

    const numNotifications = useSelector((state) =>
      state.notifications.get('numNotifications')
    );

    return (
      <AttachTooltip
        placement="bottom"
        tooltipContent={
          numNotifications > 0
            ? gt('You have unread notifications')
            : gt('You have no unread notifications')
        }
      >
        {(handlers) => (
          <span className="d-flex" {...handlers}>
            <StyledNotificationsLink
              html_url={NOTIFICATIONS_PAGE_URL}
              className="nav-link d-flex"
              activeClassName="active"
            >
              <div className="outer align-items-center">
                <span className="position-relative">
                  <i className="fa fa-fw fa-bell" />
                  {numNotifications > 0 ? (
                    <span className="unread-badge">{numNotifications}</span>
                  ) : null}
                </span>
              </div>
            </StyledNotificationsLink>
          </span>
        )}
      </AttachTooltip>
    );
  })
);

const StyledNotificationsLink = styled(FullHTMLLink)`
  font-size: 1.2rem !important;

  &:hover {
    .unread-badge {
      background: ${colors.paleBlue};
    }
  }

  .unread-badge {
    position: absolute;
    top: 5%;
    left: 55%;
    border: 2px solid ${colors.mediumGreen};
    background: ${colors.lightLinkBlue};
    border-radius: 3px;
    line-height: 1;
    font-size: 0.5rem;
    padding: 1px 2px;
    color: #00424b;
    font-weight: bold;
    min-width: 13px;
    text-align: center;
    transition: 250ms;

    &:hover {
      background: ${colors.paleBlue};
    }
  }
`;
